import { http } from '../../_shared/http';
import type { CrashReportRecord } from './types';

export const crashesApi = {
  find: (id: string) => http.get<CrashReportRecord>(`/client-crashes/${encodeURIComponent(id)}`),
};
